module.exports = __webpack_public_path__ + "img/DSC_0029.92cfc1c9.jpg";